module.exports = __webpack_public_path__ + "static/media/ismael.e0c9ce4a.jpg";